import React from "react"
import vivaldyLogo from "../../images/vivaldy-skin-clinic-logo.png"
import { IoIosMenu } from "react-icons/io"
import { Link } from "gatsby"

class Navigation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isNavbarOpened: false,
      showMenuStyles: "collapse navbar-collapse justify-content-end",
    }
  }

  handleNavbar = () => {
    this.state.isNavbarOpened
      ? this.setState({
          showMenuStyles: "collapse navbar-collapse justify-content-end",
          isNavbarOpened: false,
        })
      : this.setState({
          showMenuStyles: "collapse navbar-collapse show ",
          isNavbarOpened: true,
        })
  }

  render() {
    return (
      <React.Fragment>
        <nav className="navbar navbar-expand-lg sticky-top navbar-light bg-light shadow">
          <div className="container d-flex justify-content-between">
            <div className="navbar-brand">
              <Link to="/">
                <img
                  src={vivaldyLogo}
                  alt="Vivaldy Skin CLinic's Logo"
                  style={{ height: "3rem" }}
                />
              </Link>
            </div>
            <button
              type="button"
              className="navbar-toggler"
              onClick={() => this.handleNavbar()}
            >
              <IoIosMenu />
            </button>
            <div className={this.state.showMenuStyles}>
              <ul className="navbar-nav">
                {this.props.navigationData.map(link => {
                  if (link.link === "/")
                    return (
                      <li className="nav-item text-right brand" key={link.id}>
                        <Link
                          className="nav-link"
                          activeClassName="nav-link font-weight-bold"
                          to={link.link}
                        >
                          {link.name}
                        </Link>
                      </li>
                    )
                  return (
                    <li className="nav-item text-right brand" key={link.id}>
                      <Link
                        className="nav-link"
                        activeClassName="nav-link font-weight-bold"
                        partiallyActive
                        to={link.link}
                      >
                        {link.name}
                      </Link>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </nav>
      </React.Fragment>
    )
  }
}

export default Navigation
